import { memo, useMemo } from "react";

type Props = {
	last4: string;
	expired: string;
};

export const MaskCreditInfo = memo(({ last4, expired }: Props) => {
	const expiredDate = useMemo(() => formatExpiredDate(expired), [expired]);

	return (
		<div>
			<div className="flex flex-col gap-y-2">
				<div className="flex items-center gap-2">
					<p className="text-sm">カード番号</p>
					<p className="text-lg font-bold">{last4 ? `•••• •••• •••• ${last4}` : "登録カードがありません"}</p>
				</div>
				<div className="flex items-center gap-2">
					<p className="text-sm">有効期限</p>
					<p className="text-lg font-bold">{expiredDate}</p>
				</div>
			</div>

			<div className="text-chillnn-caption mt-7 text-xs">
				※デビットカードをご登録いただくと、現地決済手数料を請求の際、一時的に二重決済が行われる場合がございますのでご注意ください。
				<br />
				※右上のアイコンを押してカード情報を編集できます。
			</div>
		</div>
	);
});

const formatExpiredDate = (expired: string) => {
	if (!expired) return "••••/••";

	const [month, year] = expired.split("/");
	return `${year}年${month}月`;
};
